import React from 'react'

const Loading = () => {
  return <div style={ { marginTop: '300px'} }>Logging you in...</div>
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading.js